import React from 'react';
import SearchSimple from '../../../../components/SearchSimples/SearchSimple';
import DisplayView from '../../../../components/DisplayView';
import {getViewTypeByName} from '../../../../enums/ViewType';
import CustomTable from '../../../../components/table/CustomTable';
import {permissionObj} from '../../../../Helpers/permission';
import CustomButtonLink from '../../../../components/buttons/CustomButtonLink';
import routes from '../../../../Routes/routes';
import IngredientsTableApp from "./Functionality/IngredientsTableApp";

/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack
 * @Email : kpozos@ibl.mx
 *
 */
const IngredientsTable = ({
    view,
    setView,
    setBodyForExport,
    modified,
    setModified,
    selectedList,
    setSelectedList,
    isAllChecked,
    setIsAllChecked,
    handleDelete,
    option
}) => {

    const {
        t,
        DEV,
        navigate,
        permission,
        searchId,
        tableId,
        thead,
        tbody,
        rowsPerPage,
        setSearchResults,
        searchElement,
        setSearchElement,
        search,
        setSearch,
        setSimpleSearch,
        handleDeleteAll,
        handleCheckboxChange,
        getActionsButtons,
        pagination,
        deletePermission
    } = IngredientsTableApp({
        view,
        setBodyForExport,
        modified,
        setModified,
        selectedList,
        setSelectedList,
        isAllChecked,
        setIsAllChecked,
        handleDelete,
        option
    });

    return (
        <>
            <div className='d-flex'>
                <DisplayView view={view} setView={setView}/>
                <div className='w-100 ml-4'>
                    <SearchSimple
                        id={searchId}
                        setBodyForExport={setBodyForExport}
                        setSearchResults={setSearchResults}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        rowsPerPage={rowsPerPage}
                        setSimpleSearch={setSimpleSearch}
                        viewType={getViewTypeByName(view)}
                        search={search}
                        setSearch={setSearch}
                        contractorId={null}
                        supplierId={null}
                    />
                </div>
            </div>

            <CustomTable tableId={tableId}
                         searchId={searchId}
                         checkbox={deletePermission}
                         checkboxTitle={"de_/_select_all"}
                         isAllChecked={isAllChecked}
                         onChangeCheckbox={handleDeleteAll}
                         thead={thead}
                         tbody={tbody}
                         columnActions={DEV || permission?.includes(permissionObj?.WEB_INGREDIENT_DELETE) || permission?.includes(permissionObj?.WEB_INGREDIENT_UPDATE) }
                         getActionsButtons={getActionsButtons}
                         handleCheckboxChange={handleCheckboxChange}
                         selectedList={selectedList}
                         childrenNotInformation={tbody?.data?.length === 0 ? <>
                                     <div className={"warning-text"}>
                                        {!searchElement && (
                                         <p>{t("you_have_not_created_any_ingredients_yet")}</p>
                                        )}
                                     </div>
                                     { ( DEV || permission?.includes(permissionObj?.WEB_INGREDIENT_CREATE) )&&
                                     <CustomButtonLink
                                         splitName={false}
                                         id={'btn_in_create_ingredient'}
                                         card={true}
                                         onClick={() => {
                                             navigate(routes.foodieIngredient.addEdit, { state: { view: view } });
                                         }}
                                         name={'add_new_ingredient'}
                                     />
                                     }
                                 </>
                             : undefined
                         }
            />
            {pagination()}

        </>
    );
}

export default IngredientsTable;
